import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { humanizeDuration } from '../../../utils/humanizeDuration';
const defaultChartOptions = {
    responsive: true,
    tooltips: {
        mode: 'index',
        intersect: false,
        position: 'nearest',
        callbacks: {},
    },
    hover: {
        mode: 'index',
        intersect: false,
    },
    legend: {
        display: false,
    },
    scales: {
        xAxes: [
            {
                type: 'time',
                distribution: 'series',
                //bounds: 'ticks',
                time: {
                    unit: 'week',
                },
                stacked: true,
                scaleLabel: {
                    labelString: 'Time',
                },
                categoryPercentage: 1.0,
            },
        ],
        yAxes: [
            {
                stacked: true,
                scaleLabel: {
                    labelString: 'Duration',
                },
                ticks: {
                    beginAtZero: true,
                    // Seconds to milliseconds
                    callback: (value) => (value ? humanizeDuration(value, 'seconds') : ''),
                },
            },
        ],
    },
};
const colorWorkInProgress = '#031e63';
const colorReview = '#068fb1';
const colorMerged = '#33c57b';
const defaultChartData = {
    labels: [],
    datasets: [
        {
            // @TODO missing translation
            label: 'Work in Progress',
            backgroundColor: colorWorkInProgress,
            data: [],
        },
        {
            // @TODO missing translation
            label: 'Review',
            backgroundColor: colorReview,
            data: [],
        },
        {
            // @TODO missing translation
            label: 'Merge',
            backgroundColor: colorMerged,
            data: [],
        },
    ],
};
export const CycleTimeChart = ({ dateTimes, datasets }) => {
    const data = {
        ...structuredClone(defaultChartData),
        labels: dateTimes,
    };
    for (let i = 0; i < datasets.length; i++) {
        data.datasets[i].data = datasets[i];
    }
    const options = {
        ...defaultChartOptions,
        tooltips: {
            ...defaultChartOptions.tooltips,
            callbacks: {
                ...defaultChartOptions.tooltips.callbacks,
                label: (tooltipItem) => {
                    if (!tooltipItem.yLabel) {
                        return '';
                    }
                    const title = data.datasets[tooltipItem.datasetIndex].label;
                    // Seconds to milliseconds
                    const value = humanizeDuration(tooltipItem.yLabel * 1000);
                    return title + ': ' + value;
                },
            },
        },
    };
    return _jsx(Bar, { data: data, height: 140, options: options });
};
